import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslations } from "next-intl";
import { useToast } from "@/hooks/use-toast";
import { createConnectionRequestAction } from "../actions";
import { CONNECTIONS_QUERY_KEYS } from "../queries/useConnections";
import { SENT_PENDING_CONNECTION_REQUESTS_QUERY_KEYS } from "../queries/useSentPendingConnectionRequests";

type Variables = {
  connectionUserId: string;
  recipientName?: string;
};

export const useCreateConnectionRequestMutation = () => {
  const { toast } = useToast();
  const queryClient = useQueryClient();
  const t = useTranslations("modules.connections");

  return useMutation({
    mutationFn: ({ connectionUserId }: Variables) =>
      createConnectionRequestAction({ connectionUserId }),
    onSuccess: (_data, { recipientName }) => {
      toast({
        title: t("requestSentTitle"),
        description: recipientName
          ? t("requestSentDescription", { name: recipientName })
          : undefined,
      });
      queryClient.invalidateQueries({
        queryKey: CONNECTIONS_QUERY_KEYS.all,
      });
      queryClient.invalidateQueries({
        queryKey: SENT_PENDING_CONNECTION_REQUESTS_QUERY_KEYS.all,
      });
    },
    onError: () => {
      toast({
        title: t("requestErrorTitle"),
        description: t("requestErrorDescription"),
        variant: "destructive",
      });
    },
  });
};
